// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__22BIh","header":"ReportDetails_header__xNryh","title":"ReportDetails_title__1JW5H","left":"ReportDetails_left__11Utu"};